import { PlaceNote, PlaceNoteDocument } from "../types/PlaceNote";

export function mapPlaceNoteDocumentToPlaceNote(
  placeNoteDocument: PlaceNoteDocument
): PlaceNote {
  return {
    id: placeNoteDocument.id,
    placeId: placeNoteDocument.placeId,
    creatorId: placeNoteDocument.creatorId,
    noteText: placeNoteDocument.noteText,
    createdAt: placeNoteDocument.createdAt,
    updatedAt: placeNoteDocument.updatedAt,
    // Voting:
    upvotes: placeNoteDocument.upvotes,
    downvotes: placeNoteDocument.downvotes,
    voterUserIds: placeNoteDocument.voterUserIds,
    // Denormalized fields:
    creatorUsername: placeNoteDocument.creatorUsername,
    creatorProfilePictureUrl: placeNoteDocument.creatorProfilePictureUrl,
  };
}
